var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    fill: "none",
    viewBox: "0 0 16 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.649 1.747A1.969 1.969 0 0 0 14.245.344C12.987 0 8.015 0 8.015 0s-5.002 0-6.26.344A1.969 1.969 0 0 0 .351 1.747C0 2.951 0 5.53 0 5.53s0 2.55.351 3.78c.176.688.731 1.204 1.404 1.376C3.013 11 8.015 11 8.015 11s4.972 0 6.23-.315c.673-.172 1.229-.688 1.404-1.375C16 8.078 16 5.529 16 5.529s0-2.578-.351-3.782ZM6.377 7.85v-4.64l4.153 2.32-4.153 2.32Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgYoutube);
export default Memo;